module.exports = __webpack_public_path__ + "img/yanbao_yousejinshu_foot.58b4f095.png";